import React, { useState } from 'react';
import { Trans } from 'react-i18next';
import { Link } from "react-router-dom";
import { Page, FormGroup } from "components/common";
import BackButton from 'components/refactoring/BackButton';
import Dropzone from "react-dropzone";
import { LocalForm, Control, Errors } from "react-redux-form";
import { Button, Table } from "reactstrap";
import { useOrganisationContext } from "hooks";
import { ApiClient } from "services";
import { NotificationManager } from "react-notifications";
import ImportModal from 'components/ImportModal';

const ImportAsset = ({ t, match, templateName, title }) => {
    const { selectedOrganisation } = useOrganisationContext();
    const client = ApiClient();

    const [isOpen, setisOpen] = useState(false);

    const toggle = () => {
        setisOpen(!isOpen);
      };
    
    const connectedOrg = selectedOrganisation ? selectedOrganisation?.id : 0;

    const handleAssetImport = async (selectedFile) => {
        const formData = new FormData();
        console.log(selectedFile, "file file");
        
        formData.append('file', selectedFile)


        // formData.append('date_format', values.date_format);

        console.log(formData, "Form submitted");

        formData.append('status', "REGISTERED")

        client.post(`/import_bulk_assets/${connectedOrg}/assets`, formData)
        .then(({ data }) => {
          NotificationManager.success(t("File imported successfully"));
        })
        .catch((error) => {
          console.log(error.response ? error.response.data.error : "Error while importing File")
          if (error.response && error.response.data) {
            const backendError = error.response.data.error;
            console.log(backendError, "Bakcend error #");
            const errorMessage = backendError?.assetNumber ? backendError?.assetNumber[0] : JSON.stringify(backendError);
            NotificationManager.error(t(errorMessage));
        } else {
            NotificationManager.error(t("Error importing assets"));
        }
        console.error(error);
        });

    };

    const file_ame = 'ImportFixedAssetsTemplate.xlsx';

    const handleDownload = () => {
        // Construct URL to your Django view
        const fileUrl = `api/download_template_asset/?file_name=${file_ame}`;
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = file_ame; // Ensure the filename is set correctly for download
        link.click();
    };
    

    return (
        <Page title={t("Import Invoices")}>
            <BackButton />
            <Button onClick={() => toggle()}>---</Button>
            <ImportModal
                isOpen={isOpen}
                toggle={toggle}
                title="FixedAssets"
                handleUpload={handleAssetImport}
            >
        </ImportModal>
            <LocalForm>
                <p>Download our <Button color='primary' onClick={handleDownload}>Excel</Button> template to create your own import file</p>
                
                <FormGroup model=".file" className="pt-2 pb-2">
                    <Control.file
                        model=".file"
                        accept=".xlsx, .xls, .csv"
                        // className="d-none border border-primary rounded"
                        component={Dropzone}
                        multiple={false}
                        className="border border-primary rounded"
                        style={{ backgroundColor: '#F4F7FE' }}
                    >
                        <div className="m-2 text-center">
                            <div>
                                <img
                                    // alt="logo"
                                    // onLoad={onLogoLoad}
                                    // onError={onLogoError}
                                    className="img-thumbnail mb-3"
                                    // src="{item.logo}"
                                    style={{ maxWidth: "200px" }}
                                />
                            </div>
                            <span>
                                <Trans>
                                    Drop an Excel file here, or click to select a file to upload.
                                </Trans>
                            </span>
                        </div>
                    </Control.file>
                    {/* <PendingButton
                        className="mt-1"
                        onClick={() => {
                            dispatch(actions.change("local.file", null));
                        }}
                    >
                    </PendingButton> */}
                    <Errors
                        model=".file"
                        component={(props) => (
                            <p className="form-text small text-danger" {...props} />
                        )}
                        messages={{
                            invalid: t("This is not a valid Excel file"),
                        }}
                    />
                </FormGroup>

                <FormGroup label={t("Ensure asset type exist")} className='mt-3'>
                    <div className='d-grid mt-2'>
                        <div className='col mt-2'>
                            <p><Trans>Only Assets with existing asset types can be imported. New asset types listed in the import file will fail the import.</Trans></p>
                        </div>
                        <div className='col mt-2 ml-1'>
                            <Link to={`/asset-types-list`} style={{ color:'#72b566'}}><Trans>Asset Type list</Trans></Link>
                        </div>
                    </div>
                </FormGroup>

                <FormGroup model=".date_format" label={t("Select your date format")} className='mt-3'>
                    <div className='d-grid mt-2'>
                        <div className='col mt-2'>
                            <p><Trans>Asses that are not in the selected date formate will fail import</Trans></p>
                        </div>
                        <div className='row mt-2'>
                            <div className='col w-25'>
                                <Control.select model=".date_format" className="form-select p-2 w-25">
                                    <option value="select">{t("Select...")}</option>
                                    <option value="MM/DD/YYYY">MM/DD/YYYY</option>
                                    <option value="DD/MM/YYYY">DD/MM/YYYY</option>
                                    <option value="YYYY/MM/DD">YYYY/MM/DD</option>
                                </Control.select>
                            </div>
                        </div>
                    </div>
                </FormGroup>

                <FormGroup className="text-right">
                    <Button type="submit" color='primary'><Trans>Import</Trans></Button>
                </FormGroup>
            </LocalForm>
        </Page>
    );
};

export default ImportAsset;
